const drawerWidth = 240;
    
export const styles = theme => ({
    grid: {
        display: 'flex'
    },
    paper: {
        padding: 20,
        display: 'flex',
        justifyContent: 'start',
        flexDirection: 'column',
        width: '100%',
        borderRadius: 10,
        border: '0.8px solid #E4D9CE',
        position: 'relative',
        height: '100%',
        boxShadow: 'none',
        "@media print": {
            height: 'auto',
        }
    },
    paperPrint: {
        "@media print": {
            border: '0 !important'
        }
    },
    paperWithoutHeight: {
        padding: 20,
        display: 'flex',
        justifyContent: 'start',
        flexDirection: 'column',
        width: '100%',
        borderRadius: 10,
        border: '0.8px solid #E4D9CE',
        position: 'relative',
        boxShadow: 'none',
        "@media print": {
            height: 'auto',
        }
    },
    paperHeader: {
        backgroundColor: '#F4EAE1',
        marginTop: '-20px',
        marginLeft: '-20px',
        marginRight: '-20px',
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 10,
        marginBottom: 13,
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5
    },
    pageBreak: {
        display: 'block',
        breakAfter: 'page',
        pageBreakAfter: 'always',
    },
   printRoot: {
        "@media print": {
            '& $infoTable, & $partGrid': {
                breakInside: 'avoid',
                pageBreakInside: 'avoid',
            },
            '& img': {
                breakInside: 'avoid',
                pageBreakInside: 'avoid',
                maxWidth: '100% !important',
                height: 'auto',
            },
            '& $partItemTitle': {
                breakInside: 'avoid',
                pageBreakInside: 'avoid',
            },
            '& .MuiPaper-root': {
                breakInside: 'avoid',
                pageBreakInside: 'avoid',
                height: 'auto !important',
                minHeight: '0 !important',
                maxHeight: 'none !important',
                overflow: 'visible !important',
                boxShadow: 'none !important',
            },
            '& $printAllowBreak.MuiPaper-root': {
                breakInside: 'auto',
                pageBreakInside: 'auto',
            },

            '& table': { width: '100%' },
            '& tr, & td, & th': {
                breakInside: 'avoid',
                pageBreakInside: 'avoid',
            },
            '& h1, & h2, & h3, & h4, & h5': {
                breakAfter: 'avoid',
                pageBreakAfter: 'avoid',
            },

            '& canvas': {
                maxWidth: '100% !important',
                height: 'auto !important',
            },
        },
    },
    printCompact: {
        "@media print": {
            '& .MuiPaper-root': {
                padding: 10,
                marginTop: 8,
                marginBottom: 8,
            },
            '& > .MuiPaper-root': {
                marginTop: 0,
                marginBottom: 0,
            },
            '& .MuiGrid-spacing-xs-3': {
                width: 'calc(100% + 8px)',
                margin: -4,
            },
            '& .MuiGrid-spacing-xs-3 > .MuiGrid-item': {
                padding: 4,
            },
            '& .MuiTypography-body1': {
                fontSize: 12,
                lineHeight: 1.4,
            },
            '& .MuiTypography-paragraph': {
                marginBottom: 6,
            },
            '& .MuiTypography-h5': {
                fontSize: 15,
                marginBottom: 4,
            },
            '& $partItemTitle': {
                paddingBottom: 6,
                marginBottom: 4,
            },
            '& $partItemTitle .MuiTypography-root': {
                fontSize: 18,
            },
            '& $paperHeader': {
                marginTop: -10,
                marginLeft: -10,
                marginRight: -10,
                marginBottom: 6,
                paddingTop: 6,
                paddingBottom: 2,
            },
            '& $paperHeader p': {
                margin: '0 0 4px 0',
                fontSize: 11,
            },

            '& .img-responsive': {
                width: '100%',
                maxHeight: 150,
                objectFit: 'cover',
            },
        },
    },
    smallPaper: {
        padding: 10,
    },
    iframeHeight: {
        height: 'calc(100% - 5px)'
    },
    paperButtons: {
        display: 'flex',
        flexDirection: 'row',
        gap: '20px',
        marginTop: '20px',
        flexWrap: 'wrap',
        '& .MuiButton-outlined': {
            width: 'calc(100% / 3 - 20px)',
            borderRadius: 5,
            border: '0.8px solid #1836494D',
            textTransform: 'capitalize',
            color: '#2e4c5f',
            padding: '15px 10px',
            fontSize: 18,
            fontWeight: 400,
            '&:hover': {
                background: '#2e4c5f',
                color: '#FFF'
            }
        }
    },
    accordion: {
        background: 'transparent',
        border: '1px solid #8a8a8a',
        boxShadow: 'none'
    },
    dialogTitleRoot: {
        margin: 0,
        padding: '20px 20px 0',
    },
    maxWidth: {
        maxWidth: 1000,
        margin: '0 auto'
    },
    dialogImage: {
        maxWidth: '100%',
        height: 'auto'
    },
    closeButton: {
        position: 'absolute',
        right: 16,
        top: 22,
        padding: 6,
    },
    marginTop: {
        marginTop: 24,
    },
    marginBottom: {
        marginBottom: 20
    },
    marginBottomEight: {
        marginBottom: 8
    },
    marginBottomTen: {
        marginBottom: 10
    },
    textCenter: {
        textAlign: 'center',
    },
    marginTen: {
        marginTop: 10
    },
    fontTwelve: {
        fontSize: 12
    },
    textSmall: {
        fontSize: 12,
        "@media print": {
            fontSize: 10
        }
    },
    energyText: {
        marginTop: 10,
        marginBottom: 0,
        color: '#183649',
        fontWeight: 300
    },
    energySubTitle: {
        fontWeight: 300
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: 10
    },
    iframe: {
        width: '100%',
        borderRadius: 5
    },
    paragraphMargin: {
        marginBottom: theme.spacing(3),
    },
    select: {
        width: 90,
        fontSize: 13
    },
    table: {
        '& .MuiTableCell-head': {
            color: 'inherit',
            fontWeight: 400
        },
        '& .MuiTableCell-root': {
            border: 0,
            padding: '8px 8px'
        }
    },
    infoTableContainer: {
        display: 'flex',
        gap: 10,
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'start'
    },
    infoTable: {
        display: 'flex',
        gap: 5,
        justifyContent: 'space-between',
        border: '0.8px solid #E4D9CE',
        borderRadius: 5,
        flexDirection: 'row',
        padding: 15,
        "@media print": {
            padding: 5
        }
    },
    infoTableHeader: {
        display: 'flex',
        gap: 5,
        justifyContent: 'space-between',
        padding: 15
    },
    infoTableTotal: {
        backgroundColor: '#F4EAE1',
        '& p': {
            fontWeight: 600
        }
    },
    justifyContentUnset: {
        justifyContent: 'unset',
        gap: 20,
        "@media print": {
            marginTop: 10
        }
    },
    textAlignLeft: {
        textAlign: 'left'
    },
    flexColumn: {
        flexDirection: 'column'
    },
    energyTable: {
        '& .MuiTableCell-root': {
            fontWeight: 600,
        }
        
    },
    tablePadding: {
        paddingLeft: theme.spacing(1),
        margin: 0
    },
    cursor: {
        cursor: 'pointer'
    },
    underline: {
        '& span': {
            textDecoration: 'underline'
        },
        '& p': {
            margin: '2px 0 0 0',
            fontWeight: 100
        }
    },
    iconWarning: {
        color: '#F39C12',
        background: '#FFF',
        borderRadius: 50,
        marginRight: 52,
        fontSize: 30
    },
    partTypographyPadding: {
        paddingRight: 10
    },
    partGrid: {
        alignItems: 'center',
        display: 'flex',
        cursor: 'pointer',
        padding: 10,
        border: '0.8px solid #E4D9CE',
        borderRadius: 5,
        justifyContent: 'space-between',
        alignItems: 'start'
    },
    partGridContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10
    },
    partLabel: {
        color: '#C96F4A',
        backgroundColor: '#C96F4A26',
        border: '0.8px solid #C96F4A66',
        borderRadius: 5,
        fontSize: 10,
        fontWeight: 300,
        display: 'flex',
        alignItems: 'center',
        padding: 4,
        gap: 3
    },
    noPaddingTop: {
        paddingTop: 0
    },
    partAvatarContainer: {
        display: 'flex'
    },
    partAvatar: {
        width: 60,
        height: 60,
        marginRight: 15,
        borderRadius: 5 
    },
    partAvatarTextContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    partAvatarLead: {
        fontSize: 12,
        fontWeight: 300,
        marginBottom: 5
    },
    partAvatarTitle: {
        fontSize: 14,
        fontWeight: 400,
        margin: 0
    },
    partItemTitle: {
        display: 'flex',
        borderBottom: '0.8px solid #F4EAE1',
        paddingBottom: 20,
        alignItems: 'center',
        "@media print": {
            border: 0,
            padding: 0
        },
        '& .MuiTypography-root': {
            fontSize: 24,
            fontWeight: 400,
            marginBottom: 6,
        },
        '& .MuiTypography-subtitle1': {
            fontWeight: 300,
            fontSize: 14,
            color: '#748692',
            margin: 0,
            '& span': {
                color: '#183649'
            }
        }
    },
    greyText: {
        color: '#748692',
        fontWeight: 300,
        '&:last-child': {
            marginBottom: 0
        }
    },
    greyTextThin: {
        color: '#748692',
        fontWeight: 200,
        '&:last-child': {
            marginBottom: 0
        }
    },
    greyTextMedium: {
        color: '#748692',
        fontWeight: 400,
        '& p': {
            fontWeight: 300
        },
        '&:last-child': {
            marginBottom: 0
        }
    },
    blueText: {
        color: '#183649',
        fontWeight: 300,
        textAlign: 'right'
    },
    blueTextHeader: {
        color: '#183649',
        fontWeight: 400,
        textAlign: 'right'
    },
    oneThird: {
        width: 'calc(100% / 3 - 20px)'
    },
    width150: {
        width: 150,
    },
    oneSixth: {
        width: 'calc(20% - 40px)',
        textAlign: 'left',
        "@media print": {
            width: 'calc(25% - 40px)',
        }
    },
    button: {
        backgroundColor: '#89464F',
        border: '0.8px solid #B6767F',
        color: '#FDF7F2',
        fontSize: 11,
        fontWeight: 300,
        textTransform: 'unset',
        textAlign: 'right',
        justifySelf: 'end',
        display: 'flex',
        '&:hover': {
            backgroundColor: '#8F5058',
        }
    },
    faq: {
        marginBottom: 0
    },
    showImageButton: {
        justifySelf: 'center',
        marginTop: 20
    },
    serviceChip: {
        backgroundColor: 'rgba(79, 108, 101, 0.15)',
        color: '#4F6C65',
        border: '0.8px solid rgba(79, 108, 101, 0.35)',
        borderRadius: 5,
        fontSize: 14
    },
    serviceChipInactive: {
        backgroundColor: '#FDEDEE',
        color: '#d32f2f',
        border: '0.8px solid #d32f2f',
        borderRadius: 5,
        fontSize: 14
    },
    avatarGrid: {
        display: 'flex',
        marginLeft: 'auto',
        alignItems: 'end'
    },
    avatar: {
        width: 132,
        height: 132,
        marginLeft: 'auto',
        backgroundSize: 'cover',
    },
    avatarImage: {
        border: '0.8px solid #E4D9CE',
        borderRadius: 15,
    },
    iconLinks: {
        display: 'inline-flex',
        flexDirection: 'column',
        gap: 10,
        marginBottom: 5
    },
    iconlink: {
        display: 'inline-flex',
        fontSize: 14,
        alignItems: 'center',
        border: '0.8px solid #E4D9CE',
        borderRadius: 5,
        padding: 10,
        '& svg': {
            marginRight: 10
        }
    },
    logoLinks: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 10,
        '& a': {
            display: 'flex',
            paddingLeft: 6,
        }
    },
    serviceAgreement: {
        display: 'flex',
        gap: 13,
        alignItems: 'center',
        marginBottom: 10
    },
    serviceAgreementDate: {
        textTransform: 'capitalize'
    },
    checkIcon: {
        color: '#4F6C65',
        fontSize: 17,
        marginLeft: 10,
        marginRight: -8
    },
    warningIcon: {
        color: '#F39C12'
    },
    clearIcon: {
        color: '#d32f2f',
        fontSize: 17,
        marginLeft: 10,
        marginRight: -8
    },
    root: {
        display: 'flex',
        '& .MuiList-root .MuiTypography-root': {
            lineHeight: '2.1em'
        }
    },
    container: {
        width: 'calc(100% - 20px)',
        position: 'relative',
        top: '64px',
        flexGrow: 1,
        padding: '20px',
        "@media print": {
            top: 0,
            padding: 0
        }
    },
    chartHeader: {
        display: 'flex',
        marginBottom: 30
    },
    chart: {
        '& canvas': {
            maxWidth: '100%',
            maxHeight: 350,
        }
    },
    chartYear: {
        marginLeft: 'auto',
        display: 'flex',
        gap: 40,
        '& h3': {
            fontWeight: 400,
            fontSize: 18,
            textAlign: 'center',
            margin: 0,
        },
    },
    chartYearText: {
        display: 'flex',
        alignItems: 'center',
        gap: 5
    },
    chartEnergy: {
        display: 'flex',
        gap: 20,
        justifyContent: 'center',
        marginBottom: 20,
        '& .label-blue': {
            marginLeft: 15
        }
    },
    topIcons: {
        width: 100,
        height: 100,
        margin: '0 auto',
        left: 'calc(50% - 50px)',
        marginTop: '-60px'
    },
    infoIcon: {
        width: 60,
        height: 60,
        position: 'absolute',
        bottom: '-5px',
        right: '-5px'
    },
    noteIcon: {
        width: 60,
        height: 60,
        marginRight: '-15px',
        marginTop: '-15px',
        marginBottom: '-10px',
        stroke: '#99b83c'
    },
    prioritizedNotes: {
        display: 'flex',
        justifyContent: 'space-between',
        verticalAlign: 'middle',
        alignItems: 'center'
    },
    maintenanceHeaders: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '20px 12px 15px 12px',
        fontSize: 13,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        boxShadow: 'none',
        borderBottom: '1px solid #E4D9CE',
        transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: '5px',
    },
    divider: {
        borderLeft: '1px solid #E4D9CE',
        marginLeft: '23px',
        marginRight: '20px',
        height: '64px'
    },
    hide: {
        display: 'none',
    },
    hidePrint: {
        "@media print": {
                display: 'none',
        }
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    menuPaper: {
        background: theme.palette.primary.main,
        color: "#FFF",
    },
    breadcrumb: {
        fontSize: '20px'
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(6) + 1,
        [theme.breakpoints.up('sm')]: {
        width: theme.spacing(9) + 1,
        },

        '& .MuiList-root span': {
            display: 'none'
        }
    },
    navRight: {
        marginLeft: 'auto',
        display: 'flex',
        gap: 16,
    },
    rightLink: {
        display: 'inline-flex',
        gap: 8,
        alignItems: 'center',
        verticalAlign: 'middle',
    },
    toolbarContainer: {
        justifyContent: 'flex-start',
    },
    navItem: {
        display: 'flex',
        padding: '10px',
        gap: '6px',
        fontSize: '14px',
        margin: '10px 18px',
        border: '1px solid transparent',
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 20px',
        ...theme.mixins.toolbar,
    },
})